import React from 'react';

export function LoadingScreen({ isLoading }) {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-50 bg-[#0a0a0a] flex items-center justify-center">
      <div className="text-white text-2xl">Loading...</div>
    </div>
  );
}
